<script setup>
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

const mixes = ref([])

onMounted(() => {
    DataLayer.mixes.getTrending(6).then(response => {
        mixes.value = response.body
    })
})
</script>

<template>
    <div v-if="mixes && mixes.length" >
        <BaseSection
            :show-all-link="{ name: 'browse/mixes/trending' }"
            title="Trending"
            reserve-subtitle
            show-all-title="Browse More"
        >
            <MixGridBlock :mixes="mixes"/>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
